import PropTypes from "prop-types";
import React from "react";
import ActivityAvatar from "../connected/ActivityAvatar";
import ActivityContent from "../connected/ActivityContent";
import ActivityListing from "../connected/ActivityListing";
import ActivityModal from "../connected/ActivityModal";
import {
  Action,
  Body,
  Button,
  Container,
  Content,
  Image
} from "./styled/activity";

function ActivityAlert({ activityId, hasListingIds, isAgent, children }) {
  return (
    <Container>
      <Image>
        <ActivityAvatar activityId={activityId} />
      </Image>
      <Body>
        <Content>
          <ActivityContent activityId={activityId}>{children}</ActivityContent>
        </Content>
        {isAgent && (
          <Action>
            <ActivityModal
              activityId={activityId}
              render={({ openModal }) => (
                <Button
                  className="helix-btn helix-btn--tertiary"
                  onClick={openModal}>
                  View Alert
                </Button>
              )}
            />
          </Action>
        )}
        {!isAgent && hasListingIds && (
          <Action>
            <ActivityListing activityId={activityId} />
          </Action>
        )}
      </Body>
    </Container>
  );
}

ActivityAlert.propTypes = {
  activityId: PropTypes.string.isRequired,
  hasListingIds: PropTypes.bool.isRequired,
  isAgent: PropTypes.bool.isRequired
};

export default ActivityAlert;
